/**
 * Check whether the client has touch enabled
 */
export function isTouchDevice(): boolean {
    return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0
    );
}

export const matchXsQuery = window.matchMedia("(max-width: 991px)");
export const matchSmQuery = window.matchMedia("(min-width: 768px)");
export const matchMdQuery = window.matchMedia("(min-width: 992px)");
export const matchLgQuery = window.matchMedia("(min-width: 1200px)");
